class CartDeleteRequest{
    CartDeleteURL(id){
        return process.env.REACT_APP_BASEURL+"CartDelete/"+id
    }
}
export const {CartDeleteURL}=new CartDeleteRequest();